import {useMemo, useState} from 'react';

import {Spinner} from '@time-webkit/all/atoms/spinner';

import {ChevronUpIcon} from '@time-webkit/all/icons/chevron-up';
import {CheckIcon} from '@time-webkit/all/icons/check';
import {SendIcon} from '@time-webkit/all/icons/send';

import classNames from 'classnames';

import styles from './styles.module.css';

type Props = {
    isEdit?: boolean;
    loading?: boolean;
}

export const useSendButtonIcons = ({isEdit, loading}: Props) => {
    const [isRightButtonActive, setIsRightButtonActive] = useState(false);

    const leftButtonIcon = useMemo(() => {
        if (loading) {
            return <Spinner size={16} color='white' />;
        }

        return isEdit ? (
            <CheckIcon className={styles.icon} />
        ) : (
            <SendIcon className={styles.icon} />
        );
    }, [isEdit, loading]);

    const rightButtonIcon = useMemo(() => (
        <ChevronUpIcon
            width={24}
            height={24}
            className={classNames(styles.icon, styles.chevron, {
                [styles.transformed]: isRightButtonActive,
            })}
        />
    ), [isRightButtonActive]);

    return {leftButtonIcon, rightButtonIcon, setIsRightButtonActive, isRightButtonActive};
};
